import styled from 'styled-components';
import { StyledInputLabel } from '../../MonitoringRulesForm.style';
import { useMemo } from 'react';
import { REPOS_AUTO_DISCOVERY_VISIBILITY_TYPE } from '@linearb/linjs-common';
import Dropdown from 'components/base/Dropdown';

const StyledVisibilitySelector = styled.div`
  & .MuiSelect-root {
    width: 32.5rem;
    height: 2rem;
  }
`;

const VisibilitySelector = ({ onChange, selectedValues }) => {
  const options = useMemo(
    () => [
      {
        value: REPOS_AUTO_DISCOVERY_VISIBILITY_TYPE.PRIVATE,
        displayValue: 'Private'
      },
      {
        value: REPOS_AUTO_DISCOVERY_VISIBILITY_TYPE.INTERNAL,
        displayValue: 'Internal'
      },
      {
        value: REPOS_AUTO_DISCOVERY_VISIBILITY_TYPE.PUBLIC,
        displayValue: 'Public'
      }
    ],
    []
  );
  const renderSelected = selected =>
    options
      .filter(option => selected.includes(option.value))
      .map(option => option.displayValue)
      .join(', ');

  return (
    <StyledVisibilitySelector>
      <StyledInputLabel>Select repository visibility level</StyledInputLabel>
      <Dropdown
        multiple
        options={options}
        selectedValue={selectedValues}
        onChange={onChange}
        renderSelected={renderSelected}
        placeholder='Please select an option'
        dataCy='visibility-selector'
      />
    </StyledVisibilitySelector>
  );
};

export default VisibilitySelector;
